import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"100px"},
  class: "border-box"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 1,
  class: "btn btn-lg btn-primary btn-block",
  disabled: ""
}
const _hoisted_5 = { key: 1 }

import { ref, computed, onMounted } from 'vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useRequestSsoUrlCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SsoPage',
  setup(__props) {

    const email = ref('')

    const {
        invokeRequestSsoUrlCommandV1,
        invokingRequestSsoUrlCommandV1,
        succeedRequestSsoUrlCommandV1,
        validationErrors,
        errorRequestSsoUrlCommandV1,
        completedRequestSsoUrlCommandV1
    } = useRequestSsoUrlCommandV1(email)

    onMounted(() =>
    {
        document.title = 'Sign in with SSO to TransparentChoice'
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "fg-color-blue" }, "Sign-in with SSO", -1 /* CACHED */)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (!_unref(completedRequestSsoUrlCommandV1))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("label", null, "Email:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                type: "email",
                class: "form-control",
                placeholder: "Email address"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, email.value]
              ]),
              _createVNode(ValidationError, {
                context: "Email",
                errors: _unref(validationErrors)
              }, null, 8 /* PROPS */, ["errors"])
            ]),
            (!_unref(invokingRequestSsoUrlCommandV1))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeRequestSsoUrlCommandV1) && _unref(invokeRequestSsoUrlCommandV1)(...args))),
                  class: "btn btn-lg btn-primary btn-block"
                }, "Sign-in"))
              : (_openBlock(), _createElementBlock("button", _hoisted_4, "Signing-in...")),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createCommentVNode("<span>\n                    <span>Don't have an account?</span>\n                    <a href=\"/#/organizations/users/requestaccount\">Request access</a>\n                </span>")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", null, " To complete sign-in please check your mailbox. We have sent you link to sign-in to TransparentChoice via your organizational account. If you didn't receive anything please ensure that your account is valid and your organization has enabled SSO or just try again. ", -1 /* CACHED */)
          ]))])),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[9] || (_cache[9] = _createElementVNode("a", {
        href: "/#/organizations/users/signin",
        class: "btn btn-secondary btn-lg btn-block"
      }, "Sign-in with password", -1 /* CACHED */))
    ])
  ]))
}
}

})